import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './CRFViewer.css';
import Spinner from '../Common/Spinner';

const CRFViewer = ({ crfModel, columnView = 1, showTemplateName = false, templateId = null }) => {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (crfModel) {
      generateCRFHtml();
    } else if (templateId) {
      // TODO: Fetch CRF model by templateId
      setError('Template ID lookup not implemented. Please provide CRF model data.');
    }
  }, [crfModel, templateId, columnView, showTemplateName]);

  const generateCRFHtml = async () => {
    if (!crfModel) {
      setError('CRF model data is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await api.post('/crf/generate', {
        crfModel: crfModel,
        columnView: columnView,
        showTemplateName: showTemplateName
      });

      if (response.data.success) {
        setHtmlContent(response.data.html);
      } else {
        setError('Failed to generate CRF HTML');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 
                          err.response?.data?.message || 
                          err.message || 
                          'Failed to generate CRF HTML';
      setError(errorMessage);
      console.error('Error generating CRF HTML:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="crf-viewer-container">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="crf-viewer-container">
        <div className="alert alert-danger">
          <strong>Error:</strong> {error}
        </div>
      </div>
    );
  }

  return (
    <div className="crf-viewer-container">
      <div 
        className="crf-html-content" 
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </div>
  );
};

export default CRFViewer;
